<template>
	<div>
		<tableBox :exportUrl="'/Flat/ExportSelAppointment'" :slState="1"   :url="'/Flat/SelAppointment'"  :ifScreen="true" :ifSearch="true"   :columns="columns"></tableBox>
	</div>
</template>

<script>
	import tableBox from '../../../components/tableBox.vue'
	export default {
		name:'/core/accessControlCore',
		components: {
			tableBox
		},
		data() {
			return {

				columns: [
					
					{
						title: '名称',
						dataIndex: 'instrumentName',
						key: 'instrumentName',
						scopedSlots:{
							customRender:'instrumentNamess'
						},
						aligh:'center'
					},
					{
						title: '平台',
						key: 'labName',
						dataIndex: 'labName',
						
						aligh:'center'
					},
					{
							title: '预约人',
							dataIndex: 'realName',
							key: 'realName',
							scopedSlots:{
								customRender:'realName'
							},
							aligh:'center'
						},
						
					{
						title: '预约时间',
						dataIndex: 'appointmentTime',
						key: 'appointmentTime',
						aligh:'center',
						scopedSlots:{
							customRender:'appointmentTime'
						}

					},
					{
						title: '预约时长（min）',
						dataIndex: 'totalMinute',
						key: 'totalMinute',
						aligh:'center',
					
					},
					{
						title: '仪器使用效率',
						dataIndex: 'usageRatio',
						key: 'usageRatio',
						aligh:'center',
						scopedSlots:{
							customRender:'usageRatio'
						}
					
					},
					
					{
						title: '费用（元）',
						dataIndex: 'amount',
						key: 'amount',
						aligh:'center',
						scopedSlots:{
							customRender:'amount'
						}
					
					},
				
					{
						title: '状态',
						key: 'state',
						dataIndex: 'state',
						scopedSlots: {
							customRender: 'state2'
						},
						aligh:'center'
					},
					{
						title: '操作',
						dataIndex: 'instrumentCore',
						scopedSlots: {
							customRender: 'instrumentCore'
						},
						aligh:'center',
						width:"130px"
					},
				],
				
			}
		}
	};
</script>

<style>
</style>
